import { IDocumentServiceFactory, IUrlResolver } from '@fluidframework/driver-definitions';
import { IRequestHeader } from '@fluidframework/core-interfaces';

export interface DriverInfo {
  /**
   * The type of driver that can load this resource
   */
  type: DriverType;

  /**
   * The fluid URL used as driver input to load the container
   */
  documentUrl: string;

  /**
   * Headers for the container.resolve request
   */
  headers?: IRequestHeader;

  /**
   * The componentId of this particular URL.
   */
  componentId: string;

  /**
   * A bag of properties used for the createNewFlow. This should be opaque to outside users.
   */
  newFileInfoPromise?: any;

  /** A hint as to what the package name of the container for this URL might be. This could be used to eagerly prefetch container code prior to having a snapshot. */
  containerCodeHint?: string;

  /** Domains that will be connected to on the critical path from a boot performance perspective. Can be preconnected to in iframe flows to speed up boot performance */
  preconnectDomains?: string[];
}

export enum DriverType {
  SPO,
  Custom
}

export interface DriverImplementation {
  urlResolver: IUrlResolver;

  documentServiceFactory: IDocumentServiceFactory;
}
